import { put, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';

/**
 * Cобытие должно срабатывать при клике на стрелку Назад в открытом дровере Калькулятора
 */

export const CALCULATE_QUANTITY_GA_CLOSE = createAction('CALCULATE_QUANTITY_GA_CLOSE')<{
  elementText: string;
}>();

export const gaCalculateQuantityClose = createAction('GA:clickButton')<{
  elementType: string;
  elementBlock: string;
  elementName: string;
  elementText: string;
}>();

export function* putGaCalculateQuantityClose(elementText: string) {
  yield put(
    gaCalculateQuantityClose({
      elementType: 'button',
      elementBlock: 'productDetail / calc',
      elementName: 'Калькулятор товаров',
      elementText,
    }),
  );
}

export function* runCalculateQuantityCloseDetector() {
  yield takeEvery(CALCULATE_QUANTITY_GA_CLOSE, ({ payload: { elementText } }) =>
    putGaCalculateQuantityClose(elementText),
  );
}
